import {Card} from "react-bootstrap";
import React from "react";

function ServiceNiagaraConnections({data}) {
// console.log(data);


    return (
        <>


            <Card bg="light" className="m-2 overflow-hidden"  style={{ height: '7rem' }}>
                <Card.Title className="fw-bold px-2 pt-1 mb-0 fs-3 text-center dash-title">
                    Niagara Connections
                    <Card.Subtitle className={`${(data.stationsMonitoredDown > 0) ? " text-danger" : " text-light"}`}>{"There " + `${(data.stationsMonitoredDown > 1) ? "are " : "is "}` + data.stationsMonitoredDown + " monitored station" + `${(data.stationsMonitoredDown > 1) ? "s " : " "}` + "down."}
                    </Card.Subtitle>
                </Card.Title>

                <Card.Body className="fs-4 py-1">
                    <div className="fs-3 fw-bold d-inline">{data.stationsMonitored}</div>
                    <div className="d-inline"> of </div>
                    <div className="fs-3 fw-bold d-inline">{data.totalStations}</div>
                    <div className="d-inline"> total stations being monitored.</div>
                </Card.Body>

            </Card>

        </>
    );
}

export default ServiceNiagaraConnections;
